import { api } from './index';

export default {
  getCategoryList() {
      return api.get(`/categories/lists`);
  },
  getActiveCategoryList(parentId) {
    if (parentId) {
      return api.get(`/categories?parent_id=${parentId}&status=active`);
    } else {
      return api.get(`/categories?status=active`);
    }
  },
  showCategory(id) {
    return api.get(`/categories/${id}`);
  },
  updateCategory(payload) {
    return api.put(`categories`, { categories: payload });
  },
  createCategory(payload) {
    return api.post(`/categories`, { category: payload });
  },
  hideCategory(id) {
    return api.delete(`/categories/${id}`);
  },
  deleteCategory(id) {
    return api.delete(`/categories/${id}/delete`);
  },
  restoreCategory(id) {
    return api.put(`/categories/${id}/reactivate`);
  },
  updateCategoryOrder(payload) {
    return api.put(`categories/update_order`, { categories: payload });
  },
  getCategoriesRelations() {
    return api.get('/categories/relations');
  },
};
